document.addEventListener('DOMContentLoaded', () => {

     document.querySelectorAll('[data-flipdown]').forEach(el => {
        const isoDate = el.getAttribute('data-date');
        const variant = el.getAttribute('variant'); 
        const endDate = new Date(isoDate);
        const timeFromNow = endDate.getTime() / 1000;

        if ((endDate.getTime() - Date.now()) < 259200000) {
            el.classList.add("late");
        }

        new FlipDown(timeFromNow, el.id, {
            theme: variant,
            headings: ["dnů", "hodin", "minut", "sekund"]
        })
        .start()
        .ifEnded(() => {
            console.log(`Countdown ended: ${el.id}`);
        });
    });

  });


/* Run only when "isHpPage" is true */
if (document.querySelectorAll(".js-page-hp").length > 0) {
  // Floating button START
  var elements = document.querySelectorAll("[class^=vyzva-button]");
  var floating = document.getElementById("floatingButton");  
  function checkVisible(elm) {
      var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight); 
      var visibility = [];
      elm.forEach(element => {
          var rect = element.getBoundingClientRect();          
          visibility.push(!(rect.bottom < 0 || rect.top - viewHeight >= 0));
      });
      return visibility.includes(true);
  }


  window.onscroll = function() { 
      floating.style.display = checkVisible(elements) ? 'none' : 'block';
  };
  // Floating button END
}

//START Copy
function copyClipboard($input_name) {
  var value = document.querySelector("input[name=cv_" + $input_name + "").value;
  if (navigator.clipboard) {
      navigator.clipboard.writeText(value);
  }

  console.log("copied: " + value);
}
window.copyClipboard = copyClipboard;

function showCopySuccess(el) {
  console.log("here")
  var elem = document.getElementsByClassName("copy-success")
  elem.length>0? elem[0].remove():"";//.forEach((i, index)=> i.spice(index,1)):"";
  el.appendChild(document.createElement('span')).classList.add("copy-success");

  var notice = document.getElementsByClassName("copy-success")[0]

  notice.innerText="zkopírováno";

  setTimeout(function () {
    notice.remove();
  }, 2000);
}
window.showCopySuccess = showCopySuccess;
//END Copy


// popups START 
window.addEventListener('DOMContentLoaded', function () {

    // Helper functions
    function lockScroll() { 
      document.body.style.overflow = "hidden";
    }

    function unlockScrollIfNoPopups() {
      // Odemkni scroll jen pokud není žádný otevřený popup
      if (document.querySelectorAll(".js-popup-shown").length === 0) { 
        document.body.style.overflow = "";
      }
    }

    // Otevře popup podle jména
    function openPopupByName(name) {
      console.log("openPopupByName", name);

      const popupEl = document.querySelector(`*[data-popupname="${name}"]`);

      if (popupEl) {
        const parent = popupEl.parentElement;
        parent.classList.remove("inactive-modal");

        const closerBackground = parent.querySelector(".js-popups-closer-background");
        if (closerBackground) {
          closerBackground.style.display = "block";
          closerBackground.style.opacity = "0";
          setTimeout(() => {
            closerBackground.style.opacity = "1";
            closerBackground.style.transition = "opacity 0.3s";
          }, 10);
        }

        popupEl.classList.add("js-popup-shown");
        popupEl.style.display = "block";
        popupEl.style.opacity = "0";
        setTimeout(() => {
          popupEl.style.opacity = "1";
          popupEl.style.transition = "opacity 0.3s";
        }, 10);

        lockScroll();
      }
    }
    window.openPopupByName = openPopupByName;

    // Close popup element
    function closePopupElement(popupEl) {
      if (!popupEl) return;

      const parent = popupEl.parentElement;

      // Fade out background
      const closerBackground = parent.querySelector(".js-popups-closer-background");
      if (closerBackground) {
        closerBackground.style.opacity = "0";
        closerBackground.addEventListener(
          "transitionend",
          () => {
            closerBackground.style.display = "none";
            parent.classList.add("inactive-modal");
          },
          { once: true }
        );
      }

      // Fade out popup content
      popupEl.style.opacity = "0";
      popupEl.addEventListener(
        "transitionend",
        () => {
          popupEl.style.display = "none";
          popupEl.classList.remove("js-popup-shown");
          unlockScrollIfNoPopups();
        },
        { once: true }
      );
    } 
    // Close popup triggered by click on .js-popup-close
    document.addEventListener("click", (event) => {
      const closeTarget = event.target.closest(".js-popup-close");
      if (closeTarget) { 
        let popupEl = closeTarget.closest("[data-popupname]");
        if (!popupEl) { 
          popupEl = closeTarget.parentElement.querySelector("[data-popupname]");
        }
        closePopupElement(popupEl);
      }
    });

    // Trigger opening popups
    function addOnClickToPopupTriggers() {
      const popupTriggers = document.querySelectorAll(".js-popup-trigger");

      popupTriggers.forEach((trigger) => {
        trigger.onclick = function () {
          const popupName = trigger.getAttribute("data-popupshow");
          openPopupByName(popupName);
        };
      });
    }
    addOnClickToPopupTriggers(); 

    document.addEventListener("click", function(e) {
        const target = e.target.closest(".js-popup-trigger");
        if (target) {
            const popupName = target.getAttribute("data-popupshow");
            openPopupByName(popupName);
        }
    });
 
});
// popups END 